import callApi from "helpers/callApi";

/** Repeats a key per array item (`jurisdiction=DEU&jurisdiction=CO`), which callApi cannot do. */
function buildQueryString(params) {
  const search = new URLSearchParams();

  for (const [key, value] of Object.entries(params ?? {})) {
    if (value == null || value === "") continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item == null || item === "") continue;
        search.append(key, String(item));
      }
      continue;
    }

    search.append(key, String(value));
  }

  const query = search.toString();
  return query ? `?${query}` : "";
}

/** Legacy bulk notification center payload. */
export function getNotificationCenter(params = {}) {
  return callApi("/notify/notification_center", "GET", {
    only_active: true,
    ...params,
  });
}

export function getNotificationCenterTable(tableId, params = {}) {
  const safeId = encodeURIComponent(String(tableId ?? "").trim());
  const query = buildQueryString({ only_active: true, ...params });
  return callApi(`/notify/notification_center/${safeId}${query}`, "GET");
}

export function getNotificationCenterCounters(params = {}) {
  return callApi("/notify/notification_center/counters", "GET", params);
}
